import React from 'react'
import Button from '@material-ui/core/Button'
import { inject, observer } from 'mobx-react'
import { flow } from 'lodash'

import ProfileImageUploader from '../users/ProfileImageUploader'
import CalendarDropdown from '../shared/CalendarDropdown'
import withTranslation from '../hocs/withTranslation'
import Dialog from '../DialogWrapper'

const JoinedConversationDialog = ({ conversation, user, t, dialog }) => {
  if (!conversation || !user) return null

  const profileImageSection = user.hasProfileImage ? null : (
    <div>
      <h2>{t('conversation.addProfilePic')}</h2>
      <ProfileImageUploader retainModal={true} />
    </div>
  )

  return (
    <Dialog dialog={dialog} name='joinedConversation'>
      <div className='row'>
        <div className='col-xs-12 center-xs'>
          <h1>{t('conversation.yay', { name: user.firstName })}</h1>

          <p className='xtra-fat-bottom'>
            {t('conversation.confirmAttendance', { event: conversation.eventTypeSingular })}
          </p>

          {profileImageSection}

          <div className='row center-xs'>
            <CalendarDropdown conversation={conversation} />
          </div>
        </div>
      </div>
    </Dialog>
  )
}

export default flow(
  withTranslation,
  observer,
  inject(({ mst: { auth: { user }, conversations } }, { dialog }) => {
    const conversationId = dialog?.data?.conversationId || dialog?.data?.conversation_id
    const conversation = conversationId ? conversations.list.find((c) => c.id === conversationId) : null
    return { user, conversation }
  })
)(JoinedConversationDialog)
